import { getRouteApi } from "@tanstack/react-router";
import { DestinationsTable } from "./DestinationsTable";
import { SourcesTable } from "./SourcesTable";
import { SummaryCards } from "./SummaryCards";
import { SummaryHeader } from "./SummaryHeader";
import { getMonthDateRange, getCurrentMonth, getMonthYearDisplay } from "./utils/monthUtils";

const routeApi = getRouteApi("/(authed)/_layout/bookings/_tabbed/summary");

export function FeedyardSummaryDashboard() {
  const search = routeApi.useSearch();

  const currentMonthResult = getCurrentMonth();
  const currentMonth = currentMonthResult.success ? currentMonthResult.data : "january";
  const currentYear = new Date().getFullYear();

  const selectedMonth = search.month || currentMonth;
  const selectedYear = search.year || currentYear;

  const { fromDate, toDate } = getMonthDateRange(selectedMonth, selectedYear);

  const title = `Feedyard Summary - ${getMonthYearDisplay(selectedMonth, selectedYear)}`;

  return (
    <>
      <div className="p-4">
        <SummaryHeader title={title} />
      </div>

      <SummaryCards />

      {search.view === "destinations" ? (
        <DestinationsTable fromDate={fromDate} toDate={toDate} />
      ) : (
        <SourcesTable fromDate={fromDate} toDate={toDate} />
      )}
    </>
  );
}
